/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from "@wordpress/i18n";

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import {
	useBlockProps,
	InspectorControls,
	PanelColorSettings,

} from "@wordpress/block-editor";
import {
	Button,
	PanelBody,
	SelectControl,
	ToggleControl,
	TextControl,
} from "@wordpress/components";
import { Fragment, useEffect } from "@wordpress/element";

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	const { enableTourCountDown, tourCountDownLabel, labelTextColor, counterBgColor, counterTextColor } = attributes

	const labelColorSettings = [
		{
			value: labelTextColor,
			onChange: colorValue => setAttributes({ labelTextColor: colorValue }),
			label: __( "Label Color", 'wp-travel-blocks' )
		}
	];

	const counterBgColorSettings = [
		{
			value: counterBgColor,
			onChange: colorValue => setAttributes({ counterBgColor: colorValue }),
			label: __( "Counter Bg Color", 'wp-travel-blocks' )
		}
	];

	const counterTextColorSettings = [
		{
			value: counterTextColor,
			onChange: colorValue => setAttributes({ counterTextColor: colorValue }),
			label: __( "Counter Text Color", 'wp-travel-blocks' )
		}
	];

	return (
		<div {...useBlockProps()}>
			<InspectorControls>
				<PanelBody
					title={__("Tour Date Countdown Settings", "wens-haelo-pro")}
					initialOpen={true}
				>
					 {/* <ToggleControl
						label={__("Enable Tour Date CountDown")}
						checked={enableTourCountDown}
						onChange={() =>
						setAttributes({
							enableTourCountDown: !enableTourCountDown,
						})
						}
					/> */}
					<TextControl
						label={ __( 'Tour Date CountDown Label', 'wp-travel-blocks' ) }
						value={ tourCountDownLabel }
						onChange={ (value) => setAttributes( { tourCountDownLabel: value } ) }
					/>

					<PanelColorSettings
						title={__('Label Color', 'wp-travel-blocks')}
						colorSettings={labelColorSettings}
						initialOpen={false}
					/>
					
					<PanelColorSettings
						title={__('Counter Bg Color', 'wp-travel-blocks')}
						colorSettings={counterBgColorSettings}
						initialOpen={false}
					/>

					<PanelColorSettings
						title={__('Counter Text Color', 'wp-travel-blocks')}
						colorSettings={counterTextColorSettings}
						initialOpen={false}
					/>

				</PanelBody>
			</InspectorControls>
			<div className="wptravel-tour-date-countdown">
				<span
					style={{
						color: labelTextColor,
					}}
				>
					{tourCountDownLabel}
				</span>
				<div className="tour-date-countdown" data-date="2050-01-01">
					<div className="time-unit" 
						style={{
							background: counterBgColor,
						}}
					>
						<span className="time-number" id="days"
							style={{
								color: counterTextColor,
							}}
						>
							00
						</span>
						<span className="time-label"
							style={{
								color: counterTextColor,
							}}
						>
							Days
						</span>
					</div>
					<div className="time-unit"
						style={{
							background: counterBgColor,
						}}
					>
						<span className="time-number" id="hours"
							style={{
								color: counterTextColor,
							}}
						>
							00
						</span>
						<span className="time-label"
							style={{
								color: counterTextColor,
							}}
						>
							Hours
						</span>
					</div>
					<div className="time-unit"
						style={{
							background: counterBgColor,
						}}
					>
						<span className="time-number" id="minutes"
							style={{
								color: counterTextColor,
							}}
						>
							00
						</span>
						<span className="time-label"
							style={{
								color: counterTextColor,
							}}
						>
							Minutes
						</span>
					</div>
					<div className="time-unit"
						style={{
							background: counterBgColor,
						}}
					>
						<span className="time-number" id="seconds"
							style={{
								color: counterTextColor,
							}}
						>
							00
						</span>
						<span className="time-label"
							style={{
								color: counterTextColor,
							}}
						>
							Seconds
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}

